import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AssetItem from '../../../../components/asset/asset-item';
import {
  AssetItemHeaderDescription,
  AssetItemHeaderChange,
} from '../../../../components/asset/asset-item/asset-item-header';
import {
  AssetItemDataText,
  AssetItemDataChange,
} from '../../../../components/asset/asset-item/asset-item-data';

import TableRow from '../../../../components/common/table-row';
import SimpleDate from '../../../../components/common/date';
import { Percent } from '../../../../components/common/number';

import { factory } from '../../positions/asset-position/asset-position-container';

import stylesFxForwards from './fx-forwards-position.styles';
import defaultStyles from '../../positions/asset-position/asset-position.styles';

class FxForwardsPosition extends PureComponent {
  static propTypes = {
    row: PropTypes.shape({
      security: PropTypes.shape({ name: PropTypes.string }),
      valueDate: PropTypes.string,
      marketValue: PropTypes.number,
      unrealisedGL: PropTypes.number,
      unrealisedGLPercent: PropTypes.number,
      proportion: PropTypes.number,
    }),
    columnWidths: PropTypes.arrayOf(PropTypes.number).isRequired,
    screen: {
      isSmall: PropTypes.bool,
    },
  };

  static defaultProps = {
    row: {},
  };

  getDateColumnComponent(value) {
    if (!value) {
      return null;
    }
    return (
      <SimpleDate
        renderProps={{
          size: 'small',
          style: stylesFxForwards.textDate,
        }}
        value={value}
      />
    );
  }

  render() {
    const { row, columnWidths, screen } = this.props;
    const {
      security,
      valueDate,
      marketValue,
      unrealisedGL,
      unrealisedGLPercent,
      proportion,
    } = row;
    var shorten = false;

    if(screen.isSmall){
      shorten = 30;
    }

    return (
      <AssetItem>
        <TableRow style={defaultStyles.topRow}>
          <TableRow.Column
            align="left"
            width={columnWidths[0] + columnWidths[1]}
            testID="description"
          >
            <AssetItemHeaderDescription
              row={{
                description: security,
              }}
              shorten={shorten}
            />
          </TableRow.Column>
          {
            screen.isSmall &&
            <TableRow.Column width={columnWidths[2]}>
              <AssetItemHeaderChange value={unrealisedGLPercent} />
            </TableRow.Column>
          }
        </TableRow>
        <TableRow style={defaultStyles.bottomRow}>
          <TableRow.Column
            align="left"
            width={columnWidths[0]}
          >
            {this.getDateColumnComponent(valueDate)}
          </TableRow.Column>
          <TableRow.Column width={columnWidths[1]}>
            <AssetItemDataText value={marketValue} />
          </TableRow.Column>
          <TableRow.Column width={columnWidths[2]}>
            <AssetItemDataChange value={unrealisedGL} />
          </TableRow.Column>
          {
            !screen.isSmall &&
              <TableRow.Column width={columnWidths[3]}>
                <AssetItemHeaderChange value={unrealisedGLPercent} />
              </TableRow.Column>
          }
          {
            !screen.isSmall &&
            <TableRow.Column width={columnWidths[4]}>
              <Percent value={proportion}/>
            </TableRow.Column>
          }
        </TableRow>
      </AssetItem>
    );
  }
}

export default factory({
  component: FxForwardsPosition,

  rowFragmentExtend: {
    valueDate: true,
  },
});
